import React from 'react'

const useStaticChartPosition = () => {
  const containerRef = React.useRef<HTMLDivElement>(null)
  const chartRef = React.useRef<HTMLDivElement>(null)

  // Update the chart position when the container or window is scrolled
  React.useEffect(() => {
    if (!containerRef.current || !chartRef.current) {
      return
    }

    const container = containerRef.current

    const onScroll = () => {
      chartRef.current.style.top = `${container.scrollTop}px`
    }

    const objs = [container, window]

    objs.forEach(obj => {
      obj.addEventListener('scroll', onScroll)
    })

    return () => {
      objs.forEach(obj => {
        obj.removeEventListener('scroll', onScroll)
      })
    }
  })

  return { containerRef, chartRef }
}

export default useStaticChartPosition
